export class GeoLocation
{
	latitude: number;
	longitude: number;
}


// WEBPACK FOOTER //
// ./src/models/GeoLocation.ts